const selectors = {
  container: '.js-saveStatus',
};

export enum Status {
  Saving = 'saving',
  Saved = 'saved',
}

export default class SaveStatus {

  constructor(private container: HTMLDivElement) {}

  static initAll(): SaveStatus[] {
    return Array.from(document.querySelectorAll<HTMLDivElement>(selectors.container))
      .map((container) => new SaveStatus(container));
  }

  setStatus(status: Status): void {
    this.reset();
    this.container.classList.add(`-${status}`);
  }

  reset(): void {
    this.container.className = 'save-status js-saveStatus';
  }
}
